export default __webpack_public_path__ + "static/media/validation_banner.8b6b3644.jpg";